import React from "react";
import { Box } from "@gusarov-studio/rubik-ui";
import { cva } from "class-variance-authority";
import { cn } from "../../utils/cn";
import dotPattern from "./dot-pattern.svg";

const background = cva(
  "rounded-none bg-clip-content bg-no-repeat p-0 [background-size:100%_800px] xl:rounded-[32px] xl:p-4 xl:[background-size:100%_1400px]",
  {
    variants: {
      variant: {
        "gray-100": `[background-image:linear-gradient(to_bottom,#EAF2F6_0%,transparent_100%),var(--bgi)]`,
      },
    },
    defaultVariants: {
      variant: "gray-100",
    },
  },
);

interface HeroBackgroundProps extends React.PropsWithChildren {
  id?: string;
  variant: "gray-100";
  className?: string;
}

const HeroBackground: React.FC<HeroBackgroundProps> = ({ id, children, variant, className }) => {
  return (
    <Box
      id={id}
      className={cn(background({ variant }), className)}
      style={{ "--bgi": `url(${dotPattern})` } as React.CSSProperties}
    >
      {children}
    </Box>
  );
};

export { HeroBackground };
